/**
 * Enhanced ReCharge Subscription Widget Content Adder
 * 
 * This script handles adding custom content after ReCharge subscription options
 * and ensures the content persists when switching between one-time purchase and subscription
 */
(function() {
  // Define your custom content to add
  const customContent = `
    <div class="subscription-savings-info">
      <ul>
        <li>VIP discounts & perks.</li>
        <li>Pause, edit or cancel anytime.</li>
      </ul>
    </div>
  `;

  // Unique ID for our custom content
  const customContentId = 'rc-custom-subscription-info';
  
  // Track if we need to add the content (prevents repeated attempts)
  let contentNeedsAdding = true;
  
  /**
   * Add custom content after the ReCharge subscription options
   */
  function addCustomContent() {
    // If content is already there, don't add it again
    if (document.getElementById(customContentId)) {
      contentNeedsAdding = false;
      return;
    }
    
    // Look for the target element
    const targetElement = document.querySelector('.rc-selling-plans-single');
    if (!targetElement) {
      contentNeedsAdding = true;
      return;
    }

    // Create our custom content element
    const newContentElement = document.createElement('div');
    newContentElement.id = customContentId;
    newContentElement.className = 'custom-rc-content';
    newContentElement.innerHTML = customContent;

    // Insert the content after the target element
    targetElement.parentNode.insertBefore(newContentElement, targetElement.nextSibling);
    //console.log('Custom subscription content added');
    contentNeedsAdding = false;

  }

  // Separate Onetime text and price element
  function onetimeLabel(){
      if(document.querySelector('.onetime-radio .rc-radio__label.custom')){
        document.querySelector('.onetime-radio .rc-radio__label.custom').remove();
        document.querySelector('.onetime-radio .rc-radio__label:not(.custom)').removeAttribute("style");
      }
      if(document.querySelector('.subscription-radio .rc-radio__price s')){
        document.querySelector('.subscription-radio .rc-radio__price s').remove();
      }
      const onetimeElement = document.querySelector('.onetime-radio .rc-radio__label:not(.custom)').innerText;
      
      //const parts = onetimeElement.split("$");
      const parts = onetimeElement.split("PURCHASE");
      const formattedText = `<span class="rc-radio__label custom"><span>${parts[0].trim()} PURCHASE</span><span>${parts[1].trim()}</span></span>`;
        document.querySelector('.onetime-radio .rc-radio__label:not(.custom)').style.display = "none";
      //document.querySelector('.onetime-radio .rc-radio__label').innerHTML = formattedText;
      document.querySelector('.onetime-radio .rc-radio__label').insertAdjacentHTML("afterend", formattedText);

      //-------
      const subscriptionPriceElement = document.querySelector('.subscription-radio .rc-radio__price').innerText;
      document.querySelector('.subscription-radio .rc-radio__price').insertAdjacentHTML("afterbegin", `<s style="opacity: 0.5">${parts[1].trim()} &nbsp;</s>`);
  }
  if(document.querySelector('.onetime-radio')){
    setTimeout(onetimeLabel, 1000);
  }

  /**
   * Set up listeners for both radio button changes and subscription container visibility changes
   */
  function setupEventListeners() {
    // 1. Listen for changes on purchase option radio buttons
    document.addEventListener('change', function(event) {
      // Check if this is a purchase option change (one-time vs subscription)
      if (event.target.name === 'purchase_option' || 
          event.target.name === 'selling_plan' ||
          event.target.classList.contains('rc_widget__option__input')) {
        //console.log('Purchase option changed, will add custom content if needed');
        // Give the widget time to update the DOM
        setTimeout(function() {
          contentNeedsAdding = true;
          addCustomContent();
        }, 300);
      }      
    }, true);
    
    // 2. Listen for clicks anywhere in the form (captures more interaction types)
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('click', function() {
        // After any click in the form, check if we need to add content
        setTimeout(function() {
          if (contentNeedsAdding) {
            addCustomContent();
          }
          //onetimeLabel();
        }, 300);
      }, true);
    }
  }
  
  /**
   * Set up a mutation observer to watch for changes to the ReCharge widget
   */
  function setupMutationObserver() {
    // Find a suitable container to observe
    const container = document.querySelector('.rc-widget-injection-parent') || 
                      document.querySelector('form[action*="/cart/add"]') ||
                      document.querySelector('.product__info-wrapper');
    
    if (!container) {
      // If we can't find a container yet, try again soon
      setTimeout(setupMutationObserver, 500);
      return;
    }
    
    // Create a MutationObserver to watch for DOM changes
    const observer = new MutationObserver(function(mutations) {
      // For any DOM change, check if we need to add our content
      if (contentNeedsAdding || !document.getElementById(customContentId)) {
        setTimeout(addCustomContent, 300);
      }
      //onetimeLabel();
      if(document.querySelector('.onetime-radio')){
        setTimeout(onetimeLabel, 500);
      }
    });
    
    // Start observing the container for all changes
    observer.observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true
    });
    
    //console.log('Mutation observer set up for ReCharge widget');
  }
  
  /**
   * Continuously check for the ReCharge widget and try to add content
   */
  function monitorForRechargeWidget() {
    // Track attempted checks
    let attempts = 0;
    const maxAttempts = 100; // 50 seconds max (500ms intervals)
    
    // Check periodically
    const checkInterval = setInterval(function() {
      attempts++;
      
      // If our content is already added, clear the interval
      if (document.getElementById(customContentId) && !contentNeedsAdding) {
        // Do nothing, continue monitoring
      } 
      // Try to add our content
      else if (document.querySelector('.rc-selling-plans-single')) {
        contentNeedsAdding = true;
        addCustomContent();
      }
      else if(document.querySelector('.onetime-radio')){
       onetimeLabel(); 
      }
      
      // Stop checking after max attempts
      if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        //console.log('Max attempts reached for ReCharge widget monitoring');
      }
    }, 500);
    
    // Also set up the mutation observer and event listeners
    setupMutationObserver();
    setupEventListeners();
  }
  
  // Initialize the script when the page is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Start with a slight delay to ensure page is fully loaded
      setTimeout(monitorForRechargeWidget, 500);
      setTimeout(onetimeLabel, 800);
    });
  } else {
    // If DOM is already loaded, start immediately
    setTimeout(monitorForRechargeWidget, 500);
    setTimeout(onetimeLabel, 800);
  }

  const checkDivInterval = setInterval(() => {
    const targetDiv = document.querySelector('.onetime-radio');
    
    if (targetDiv && getComputedStyle(targetDiv).display !== "none") {
        onetimeLabel();
        clearInterval(checkDivInterval); // Stop checking once visible
    }
}, 500);
    setTimeout(() => {
      clearInterval(checkDivInterval);
      //console.log("Stopped checking after 1 minute.");
  }, 5000);
  
})();